<!--<a href="#"
   class="arrow-back"
   wcag-dummy-link-target
   aria-label="Back"
   (click)="returnPreviousLocation($event)"
   (keypress)="returnPreviousLocation($event)">
  <fa-icon class="float-left back-icon"  [icon]="['fas', 'chevron-left']"></fa-icon>
  <span style="display: none">back</span>
</a>-->
<h2 class="title">{{ title | translate }}</h2><div id="document-viewer">

    <div style=" height: 600px">
    <!-- <ng2-pdfjs-viewer
    #pdfViewerOnDemand
    [download]="false"
    [openFile]="false"
    [print]="false"
    [page]="1"
    [viewBookmark]="false">
    </ng2-pdfjs-viewer> -->
</div>

</div>